export default {
  root: {}
}
